export default "__VITE_ASSET__Ce8$vQBe__"